import React from 'react';

interface Props {
  size?: number;
  className?: string;
}

const WhatsAppIcon: React.FC<Props> = ({ size = 20, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    <path d="M12.04 2C6.48 2 2 6.48 2 12.04c0 1.99.52 3.85 1.42 5.46L2 22l4.7-1.23A9.95 9.95 0 0 0 12.04 22C17.6 22 22.08 17.52 22.08 12c0-5.56-4.48-10-10.04-10zM17.47 15.9c-.27.76-1.59 1.46-2.18 1.58-.6.12-1.04.17-2.03-.17-1.64-.53-3.01-1.98-3.33-2.25-.32-.27-1.07-.9-1.07-1.95 0-1.05.48-1.68.83-2.01.35-.33.77-.38 1.01-.38.24 0 .49.01.7.02.24.01.44-.09.69.17.25.27.86 1.04.94 1.12.08.08.13.18.06.34-.06.16-.09.26-.18.38-.09.12-.18.26-.05.5.13.24.62.98 1.34 1.6.97.78 1.8 1.11 2.18 1.26.38.15.61.12.84.07.23-.05.95-.34 1.09-.67.14-.33.14-.6.1-.67-.04-.07-.18-.13-.44-.22z" />
  </svg>
);

export default WhatsAppIcon;
